// src/pages/Blog.jsx
import Layout from "../layouts/Layout";
import Breadcrumb from "../components/Breadcrumb";
import BlogSection from "../components/Blog/BlogSection";

const Blog = () => (
  <Layout>
    <Breadcrumb
      title="Bài viết"
      parent={{ name: "Trang chủ", path: "/" }}
    />
    <BlogSection />
  </Layout>
);

export default Blog;
